import { useSelector } from 'react-redux'
import {
  selectPrefersCrmContactsPageEnabled,
  selectPrefersHelplyAgentReady,
  selectCustomerMcpRolloutEnabled,
} from 'selectors/app/selectAccountPreferences'

const FEATURE_SELECTORS = {
  'crm-contacts-page-enabled': selectPrefersCrmContactsPageEnabled,
  'helply-agent-ready': selectPrefersHelplyAgentReady,
  customer_mcp: selectCustomerMcpRolloutEnabled,
}

const useAccountFeatureFlag = featureName => {
  const selector = FEATURE_SELECTORS[featureName]
  if (!selector) throw new Error(`Unknown feature flag: ${featureName}`)
  return useSelector(selector)
}

export default useAccountFeatureFlag
